module.exports = __webpack_public_path__ + "img/4.8dcc05d6.jpg";